import { AutogenLayoutIntercompanyAssetInfo } from "./autogen/AutogenLayoutIntercompanyAssetInfo";

export class IntercompanyAssetInfo extends AutogenLayoutIntercompanyAssetInfo {

}
